import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
    parse(value: any): Date | null {
        if (value instanceof Date) {
            return value;
        }

        if (!value || typeof value !== 'string') {
            return null;
        }

        const match = value.match(/^(\d{2})[/-](\d{2})[/-](\d{4})$/);
        if (!match) {
            return new Date(NaN);
        }

        const [day, month, year] = value.split(/[-/]/).map(Number);
        const date = new Date(year, month - 1, day);

        if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
            return new Date(NaN);
        }

        return date;
    }
}
